import styled from 'styled-components';
import { COLORS, MQS, SPACINGS, FONT_FAMILY, SHADOWS } from '../../../app/common/constants/styles';

export const CurrencyBase = styled.div`
    display: flex;
    padding: 12px 24px;
    margin-bottom: 32px;
    border-radius: 4px;
    position: relative;
    box-shadow: ${SHADOWS.level1};
    background-color: ${COLORS.white};
    flex-direction: row;

    @media (min-width: ${MQS.mq2Min}) {
        justify-content: flex-end;
    }
`;

export const CurrencyLabelIconContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: flex-end;
    margin-left: 8px;

    @media (min-width: ${MQS.mq2Min}) {
        flex-direction: row;
        margin-left: 0;
        margin-right: 6px;
        width: 75%;
    }
`;

export const CurrencyLabel = styled.span`
    display: flex;
    ${FONT_FAMILY.multipleRegularCss};
    font-size: 1rem;
    align-items: center;
    justify-content: center;
    padding-top: 4px;
    flex-direction: column;
    margin-right: 12px;

    @media (min-width: ${MQS.mq2Min}) {
        font-size: 1.125rem;
    }
`;

export const CurrencyIcon = styled.div`
    margin: 0 12px 0 12px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const DropdownSelector = styled.div`
    background: ${COLORS.lightGrey};
    border-radius: 4px;
    display: inline-table;

    & button {
        padding: ${SPACINGS.base}px ${SPACINGS.base * 2}px;
    }

    & ul {
        right: 0px;
        top: 32px;
        max-width: 150px;
        width: 40vw;
    }
`;

export const ErrorMessage = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
`;

export const ErrorIcon = styled.div`
    margin-right: 10px;
`;
